import { createFileRoute } from "@tanstack/react-router";
import AdminPartsCustomers from "@/pages/admin/AdminPartsCustomers";

export const Route = createFileRoute("/_adminLayout/admin/parts/customers/")({
  component: AdminPartsCustomers,
});